/**
 * S2 (AB#2205, SG-17) — a staff member's workplace on their Profile: salon,
 * branch(es), position and role, read-only (set by the salon owner). Rendered
 * only for staff sessions; data from GET /salon-staff/me.
 */
import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useStaffMe } from '../../../hooks/useStaffSelf';
import { branchesText, localizedName, roleLabelText } from '../../../lib/staffDisplay';
import styles from './Profile.module.css';

const StaffWorkplace: React.FC = () => {
    const { t, language } = useLanguage();
    const { data: me, isLoading } = useStaffMe();
    if (isLoading || !me) return null;
    const empty = '—';
    const rows: { label: string; value: string }[] = [
        { label: t('stf.profile.salon'), value: localizedName(me.businessName, me.businessNameAr, language) || empty },
        { label: t('stf.profile.branches'), value: branchesText(me, language, t) || empty },
        { label: t('stf.profile.position'), value: me.position || empty },
        { label: t('stf.profile.role'), value: roleLabelText(me.roleLabel, t) },
    ];
    return (
        <section className={styles.workplace} aria-labelledby="profile-workplace" data-testid="staff-workplace">
            <div className={styles.cardHeader}>
                <h2 id="profile-workplace" className={styles.cardTitle}>{t('stf.profile.workplace')}</h2>
            </div>
            <p className={styles.cardLabel}>{t('stf.profile.readOnly')}</p>
            {rows.map(r => (
                <div className={styles.cardRow} key={r.label}>
                    <div className={styles.cardLabel}>{r.label}</div>
                    <div className={styles.cardValue}><bdi>{r.value}</bdi></div>
                </div>
            ))}
        </section>
    );
};

export default StaffWorkplace;
